import React from 'react';
import './Program.css'; // (선택)

export default function Program() {
  return (
    <div className="program-page">
      <h1>프로그램 소개</h1>
      {/* ...내용... */}
    </div>
  );
}